import { Injectable } from "@angular/core";
import { NGXLogger as LoggerService } from "ngx-logger";
import { Observable } from "rxjs";
import { Subject } from "rxjs";
import { NavigationService } from "./navigation.service";

@Injectable({
    providedIn: 'root'
})

export class ActionBarService {
    private editPollSettingsSubject = new Subject<void>();
    private addOptionSubject = new Subject<string>();
    private refreshOptionsSubject = new Subject<void>();

    constructor(
        private logger: LoggerService,
        public navigationService: NavigationService,

    ) {
    }

    get editPollSettingsObservable(): Observable<void> {
        return this.editPollSettingsSubject.asObservable();
    }

    get addOptionObservable(): Observable<string> {
        return this.addOptionSubject.asObservable();
    }
    get refreshOptionsObservable(): Observable<void> {
        return this.refreshOptionsSubject.asObservable();
    }

    async triggerEditPollSettings() {
        this.logger.log('triggerEditPollSettings');
        this.editPollSettingsSubject.next(null);
    }

    async triggerAddOption(optionType: string) {
        this.logger.log('triggerAddOption', optionType);
        this.addOptionSubject.next(optionType);
    }

    async triggerRefreshOptions() {
        this.logger.log('triggerRefreshOptions',);
        this.refreshOptionsSubject.next();
    }
}


